var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { class: { loading: _vm.loading } }, [
    _c(
      "div",
      { staticClass: "image-wrapper" },
      [
        _vm.loading ? _c("SearchBannerImageSkeleton") : _vm._e(),
        _vm._v(" "),
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading && _vm.imageSrc,
              expression: "!loading && imageSrc",
            },
          ],
          attrs: {
            src: _vm.imageSrc,
            alt: _vm.imageAlt,
            width: "168",
            height: "192",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c(
          "header",
          [
            _vm.loading
              ? _c("SearchBannerContentSkeleton")
              : [
                  _c("h2", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ]),
                  _vm._v(" "),
                  _vm.description
                    ? _c("p", { staticClass: "description" }, [
                        _vm._v(_vm._s(_vm.description)),
                      ])
                    : _vm._e(),
                ],
          ],
          2
        ),
        _vm._v(" "),
        _vm._t("default"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }